
export enum ShowStatus {
  Unknown = 0,
  NotRecognized = 1,
  Imported = 2,
  Published = 3
}
